import { catchError, finalize, map, share } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs/observable/of';
import * as moment from 'moment';
import { ConfigService } from '@app/core/config.service';
import { COOKIES, ENDPOINTS } from '@app/app.constants';
import * as i0 from "@angular/core";
import * as i1 from "../../config.service";
import * as i2 from "ngx-cookie-service/cookie-service/cookie.service";
import * as i3 from "@angular/common/http";
export class AuthenticationService {
    constructor(configService, cookieService, httpClient) {
        this.configService = configService;
        this.cookieService = cookieService;
        this.httpClient = httpClient;
        this.baseUrl = this.configService.getValue('baseUrl');
        this.durationIsLoggedInCookie = this.configService
            .getValue(COOKIES.durationIsLoggedInCookie);
    }
    /**
     * Gets user authentication status and check if it is valid
     * @returns Auth status
     */
    getAndCheckStatus() {
        // Validation to avoid multiple http calls
        if (!this.observableAuthzStatus) {
            this.observableAuthzStatus = this.getStatus()
                .pipe(share(), map((response) => {
                if (response.isLoggedIn) {
                    this.setLoggedInCookie(response);
                }
                else {
                    this.isLoggedInStatus = false;
                    this.checkStatusCall = true;
                }
                return response.isLoggedIn;
            }), catchError(() => {
                this.isLoggedInStatus = false;
                this.checkStatusCall = true;
                return of(false);
            }), finalize(() => {
                delete this.observableAuthzStatus;
            }));
        }
        return this.observableAuthzStatus;
    }
    /**
     * Gets user authentication status
     * @returns Log in status call
     */
    getStatus() {
        return this.httpClient.get(`${this.baseUrl}${ENDPOINTS.authenticationStatus}`);
    }
    /**
     * Validates if user is logged in
     * @returns boolean value that indicates if user is logged in
     */
    isLoggedIn() {
        const isLoggedInCookie = this.cookieService.get(COOKIES.isLoggedIn);
        let loginDetails;
        try {
            loginDetails = JSON.parse(isLoggedInCookie);
        }
        catch (error) {
            loginDetails = null;
        }
        return !!loginDetails && loginDetails.isLoggedIn ? of(true) : this.checkStatus();
    }
    /**
     * Once the first status call has ended then
     * Check is page has fully loaded before making the next status call
     * @returns boolean value that indicates is user is logged in
     */
    checkStatus() {
        let isLoggedIn;
        if (this.checkStatusCall) {
            isLoggedIn = of(this.isLoggedInStatus);
        }
        else {
            isLoggedIn = this.getAndCheckStatus();
        }
        return isLoggedIn;
    }
    /**
     * Set checkStatusCall property
     * @param checkStatusCall
     */
    setCheckStatusCall(checkStatusCall) {
        this.checkStatusCall = checkStatusCall;
    }
    /**
     * Save isLoggedIn cookie from status response
     * @param loginDetails status response
     */
    // IMPORTANT: THIS FUNCTION WILL BE USEFUL WHEN LOGIN SERVICE IS FULLY IMPLEMENTED
    setLoggedInCookie(loginDetails) {
        const cookieValue = JSON.stringify({
            isLoggedIn: loginDetails.isLoggedIn
        });
        const expires = moment().add(this.durationIsLoggedInCookie, 'minutes').toDate();
        this.cookieService.set(COOKIES.isLoggedIn, cookieValue, expires, '/');
    }
}
AuthenticationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthenticationService_Factory() { return new AuthenticationService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.CookieService), i0.ɵɵinject(i3.HttpClient)); }, token: AuthenticationService, providedIn: "root" });
